import React from "react";
import {
  Building2,
  FileText,
  Calendar,
  Users,
  Shield,
  ArrowLeft,
  CheckCircle2,
} from "lucide-react";
import { Link } from "react-router-dom";
import HeaderMenu from "../../component/Navbar/headermenu";
import CustomFooter from "../../component/Footer/customFooter";

const CAFirmsPage = () => {
  const features = [
    {
      icon: <FileText size={26} />,
      title: "Client Document Management",
      description:
        "Centralize all client files, tax documents, and compliance records in one secure location with version control.",
    },
    {
      icon: <Calendar size={26} />,
      title: "Deadline Tracking",
      description:
        "Never miss a filing deadline again with automated reminders and visual deadline calendars.",
    },
    {
      icon: <Users size={26} />,
      title: "Client Portal",
      description:
        "Give clients secure access to their documents and status updates without endless email chains.",
    },
    {
      icon: <Shield size={26} />,
      title: "Compliance Workflows",
      description:
        "Build repeatable workflows for tax seasons, audits, and regulatory filings.",
    },
  ];

  const benefits = [
    "Reduce client email volume by 60%",
    "Track every client engagement in one place",
    "Automate tax season reminders and follow-ups",
    "Secure document sharing with audit trails",
    "Multi-step approval workflows for complex filings",
  ];

  return (
    <>
      <HeaderMenu />
      <div className="CA_class_main">
        {/* Navigation */}
        {/* <div className="CA_class_nav">
        <Link to="/" className="CA_class_back_link">
          <ArrowLeft size={18} />
          Back to About
        </Link>
      </div> */}

        {/* Hero Section */}
        <section className="CA_class_hero">
          <div className="CA_class_container">
            <div className="CA_class_hero_content">
              <div className="CA_class_icon_box">
                <Building2 size={34} />
              </div>

              <h1 className="CA_class_heading">
                Work Clarity Software built for CA Firms{" "}
              </h1>

              <p className="CA_class_subheading">
                Manage client documents, deadlines, and multi-step compliance
                workflows without losing sleep over missed emails.
              </p>
            </div>
          </div>
        </section>

        {/* Features */}
        <section className="CA_class_features_section">
          <div className="CA_class_container">
            <h2 className="CA_class_section_title">
              Everything you need for modern professional practice
            </h2>

            <div className="CA_class_features_grid">
              {features.map((feature, index) => (
                <div key={index} className="CA_class_feature_card">
                  <div className="CA_class_feature_icon">{feature.icon}</div>

                  <h3 className="CA_class_feature_title">{feature.title}</h3>

                  <p className="CA_class_feature_description">
                    {feature.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Benefits */}
        <section className="CA_class_benefits_section">
          <div className="CA_class_container">
            <div className="CA_class_benefits_wrapper">
              <h2 className="CA_class_section_title CA_class_center">
                Why CA firms choose Simplifyte
              </h2>

              <div className="CA_class_benefits_list">
                {benefits.map((benefit, index) => (
                  <div key={index} className="CA_class_benefit_item">
                    <CheckCircle2 size={24} className="CA_class_check_icon" />

                    <p>{benefit}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="CA_class_cta_section">
          <div className="CA_class_container">
            <div className="CA_class_cta_box">
              <h2 className="CA_class_cta_title">
                Ready to simplify your practice?
              </h2>

              <p className="CA_class_cta_text">
                Join CA firms who've reduced client communication chaos and
                never miss a deadline.
              </p>

              <button
                className="CA_class_cta_button"
                onClick={() =>
                  (window.location.href = "https://app.simplifyte.com")
                }
              >
                Start Free Trial
              </button>
            </div>
          </div>
        </section>
      </div>
      <CustomFooter />
    </>
  );
};

export default CAFirmsPage;
